/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Participant } from './Participant';
import {
    ParticipantFromJSON,
    ParticipantFromJSONTyped,
    ParticipantToJSON,
    ParticipantToJSONTyped,
} from './Participant';
import type { DomainMinimal } from './DomainMinimal';
import {
    DomainMinimalFromJSON,
    DomainMinimalFromJSONTyped,
    DomainMinimalToJSON,
    DomainMinimalToJSONTyped,
} from './DomainMinimal';

/**
 * 
 * @export
 * @interface ChatChannel
 */
export interface ChatChannel {
    /**
     * Unique identifier of the chat channel
     * @type {string}
     * @memberof ChatChannel
     */
    id: string;
    /**
     * Display name of the chat channel
     * @type {string}
     * @memberof ChatChannel
     */
    name: string;
    /**
     * The domain this channel is associated with
     * @type {DomainMinimal}
     * @memberof ChatChannel
     */
    domain: DomainMinimal;
    /**
     * Current status of the chat channel
     * @type {string}
     * @memberof ChatChannel
     */
    status: ChatChannelStatusEnum;
    /**
     * Resolution state of the chat channel
     * @type {string}
     * @memberof ChatChannel
     */
    resolution: ChatChannelResolutionEnum;
    /**
     * All participants in this channel
     * @type {Array<Participant>}
     * @memberof ChatChannel
     */
    participants: Array<Participant>;
    /**
     * The time this channel was created
     * @type {Date}
     * @memberof ChatChannel
     */
    createdAt: Date;
    /**
     * The time of the last client message in the channel
     * @type {Date}
     * @memberof ChatChannel
     */
    lastClientActivity?: Date;
    /**
     * The time of the last agent message in the channel
     * @type {Date}
     * @memberof ChatChannel
     */
    lastAgentActivity?: Date;
}


/**
 * @export
 */
export const ChatChannelStatusEnum = {
    New: 'NEW',
    Unread: 'UNREAD',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Archived: 'ARCHIVED',
    UserEndedChat: 'USER_ENDED_CHAT',
    AgentEndedChat: 'AGENT_ENDED_CHAT',
    InactivityEndedChat: 'INACTIVITY_ENDED_CHAT',
    Deleted: 'DELETED'
} as const;
export type ChatChannelStatusEnum = typeof ChatChannelStatusEnum[keyof typeof ChatChannelStatusEnum];

/**
 * @export
 */
export const ChatChannelResolutionEnum = {
    Resolved: 'RESOLVED',
    Unresolved: 'UNRESOLVED'
} as const;
export type ChatChannelResolutionEnum = typeof ChatChannelResolutionEnum[keyof typeof ChatChannelResolutionEnum];


/**
 * Check if a given object implements the ChatChannel interface.
 */
export function instanceOfChatChannel(value: object): value is ChatChannel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('resolution' in value) || value['resolution'] === undefined) return false;
    if (!('participants' in value) || value['participants'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ChatChannelFromJSON(json: any): ChatChannel {
    return ChatChannelFromJSONTyped(json, false);
}

export function ChatChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'domain': DomainMinimalFromJSON(json['domain']),
        'status': json['status'],
        'resolution': json['resolution'],
        'participants': ((json['participants'] as Array<any>).map(ParticipantFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'lastClientActivity': json['lastClientActivity'] == null ? undefined : (new Date(json['lastClientActivity'])),
        'lastAgentActivity': json['lastAgentActivity'] == null ? undefined : (new Date(json['lastAgentActivity'])),
    };
}

export function ChatChannelToJSON(json: any): ChatChannel {
    return ChatChannelToJSONTyped(json, false);
}

export function ChatChannelToJSONTyped(value?: ChatChannel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'domain': DomainMinimalToJSON(value['domain']),
        'status': value['status'],
        'resolution': value['resolution'],
        'participants': ((value['participants'] as Array<any>).map(ParticipantToJSON)),
        'createdAt': value['createdAt'].toISOString(),
        'lastClientActivity': value['lastClientActivity'] == null ? value['lastClientActivity'] : value['lastClientActivity'].toISOString(),
        'lastAgentActivity': value['lastAgentActivity'] == null ? value['lastAgentActivity'] : value['lastAgentActivity'].toISOString(),
    };
}

